module.exports = __webpack_public_path__ + "assets/img/80.5edb098f.png";